import fetch from '../utils/fetch'

export function saveRegisterPromotions (query) {
  return fetch({
    url: '/promotions/register',
    method: 'post',
    data: query
  })
}
export function changeShowOne (query) {
  return fetch({
    url: '/promotions/seckillactivity/deleteSome',
    method: 'post',
    data: query
  })
}
export function changeLimitShowOne (query) {
  return fetch({
    url: '/promotions/limit/deleteSome',
    method: 'post',
    data: query
  })
}
export function getRegisterPromotions (query) {
  return fetch({
    url: '/promotions/register',
    method: 'get',
    params: query
  })
}
export function saveYibao (query) {
  return fetch({
    url: '/yibao/marking',
    method: 'post',
    data: query
  })
}

export function getYibao (query) {
  return fetch({
    url: '/yibao/marking',
    method: 'get',
    params: query
  })
}
export function saveRegisterPoint (query) {
  return fetch({
    url: '/promotions/point',
    method: 'post',
    data: query
  })
}

export function getPointRule (query) {
  return fetch({
    url: '/member/point/rule',
    method: 'get',
    params: query
  })
}

export function savePointRule (query) {
  return fetch({
    url: '/member/point/rule',
    method: 'put',
    data: query
  })
}

export function getRegisterPoint (query) {
  return fetch({
    url: '/promotions/point',
    method: 'get',
    params: query
  })
}

export function getSmsBasic () {
  return fetch({
    url: '/sms/basic',
    method: 'get'
  })
}

export function getSmsTemplateList () {
  return fetch({
    url: '/sms/templates',
    method: 'get'
  })
}

export function updateSmsTemplate (query) {
  return fetch({
    url: '/sms/template',
    method: 'patch',
    params: query
  })
}

export function getSmsSign () {
  return fetch({
    url: '/sms/sign',
    method: 'get'
  })
}

export function saveSmsSign (query) {
  return fetch({
    url: '/sms/sign',
    method: 'post',
    data: query
  })
}

export function addBargins (query) {
  return fetch({
    url: '/promotions/bargains',
    method: 'post',
    data: query
  })
}

export function updateBargains (bargainId, query) {
  return fetch({
    url: '/promotions/bargains/' + bargainId,
    method: 'put',
    data: query
  })
}

export function terminateBargains (bargainId) {
  return fetch({
    url: '/promotions/bargains/termination/' + bargainId,
    method: 'put'
  })
}

export function getBargainsDetail (bargainId) {
  return fetch({
    url: '/promotions/bargains/' + bargainId,
    method: 'get'
  })
}

export function deleteBargains (bargainId) {
  return fetch({
    url: '/promotions/bargains/' + bargainId,
    method: 'delete'
  })
}

export function listBargins (query) {
  return fetch({
    url: '/promotions/bargains',
    method: 'get',
    params: query
  })
}

export function getActivity (query) {
  return fetch({
    url: '/promotions/activity/lists',
    method: 'get',
    params: query
  })
}

export function isValidActivity (query) {
  return fetch({
    url: '/promotions/activity/validNum',
    method: 'post',
    data: query
  })
}

export function invalidActivity (query) {
  return fetch({
    url: '/promotions/activity/invalid',
    method: 'put',
    params: query
  })
}

export function createActivity (query) {
  return fetch({
    url: '/promotions/activity/create',
    method: 'post',
    data: query
  })
}

export function giveCoupons (query) {
  return fetch({
    url: '/promotions/activity/give',
    method: 'post',
    data: query
  })
}

export function getCouponLogList (query) {
  return fetch({
    url: '/promotions/activity/coupon',
    method: 'get',
    params: query
  })
}

// 删除线下优惠券
export function delOfflineCoupons (query) {
  return fetch({
    url: '/discountcard/delofflinecardOne',
    method: 'post',
    params: query
  })
}



export function getGiveLogList (query) {
    return fetch({
        url: '/promotions/activity/give',
        method: 'get',
        params: query
    })
}

export function getGiveErrorLogList (id, query) {
  return fetch({
    url: '/promotions/activity/give/' + id,
    method: 'get',
    params: query
  })
}

//以下为新的注册营销
export function getDistributorList(query) {
  return fetch({
    url: '/promotions/distributor',
    method: 'get',
    params: query
  })
}

// 拼团活动
export function getGroupsList (query) {
  return fetch({
    url: '/promotions/groups',
    method: 'get',
    params: query
  })
}

// 拼团活动
export function getGroupsTeamList (group_id, query) {
  return fetch({
    url: '/promotions/groups/' + group_id + '/team/',
    method: 'get',
    params: query
  })
}

export function getRegisterList(query) {
  return fetch({
    url: '/promotions/register/distributor',
    method: 'get',
    params: query
  })
}

export function getRegisterInfo(id) {
  return fetch({
    url: '/promotions/register/distributor/' +id,
    method: 'get',
  })
}

export function deleteRegister(id) {
  return fetch({
    url: '/promotions/register/distributor/' +id,
    method: 'delete',
  })
}

export function createRegister (query) {
  return fetch({
    url: '/promotions/register/distributor',
    method: 'post',
    data: query
  })
}

export function getGroupsTeamInfo (team_id, query) {
  return fetch({
    url: '/promotions/groups/team/' + team_id,
    method: 'get',
    params: query
  })
}

export function getGroupsInfo (group_id, query) {
  return fetch({
    url: '/promotions/groups/' + group_id,
    method: 'get',
    params: query
  })
}

export function createGroupActivity (params) {
  return fetch({
    url: '/promotions/groups',
    method: 'post',
    data: params
  })
}

export function updateGroupActivity (group_id, params) {
  return fetch({
    url: '/promotions/groups/' + group_id,
    method: 'put',
    data: params
  })
}

export function finishGroupActivity (group_id) {
  return fetch({
    url: '/promotions/groups/finish/' + group_id,
    method: 'put'
  })
}

export function deleteGroupActivity (group_id) {
  return fetch({
    url: '/promotions/groups/' + group_id,
    method: 'delete'
  })
}

export function getPopularizeSetting() {
  return fetch({
    url: '/popularize/config',
    method: 'get'
  })
}

export function setPopularizeSetting(data) {
  return fetch({
    url: '/popularize/config',
    method: 'post',
    data: data
  })
}

export function addPromoter(data) {
  return fetch({
    url: '/popularize/promoter/add',
    method: 'post',
    data: data
  })
}

export function getPopularizeList(data) {
  return fetch({
    url: '/popularize/promoter/list',
    method: 'get',
    params: data
  })
}

export function getPopularizeChildren(data) {
  return fetch({
    url: '/popularize/promoter/children',
    method: 'get',
    params: data
  })
}

export function editPopularizeRemove(data) {
  return fetch({
    url: '/popularize/promoter/remove',
    method: 'put',
    data: data
  })
}

export function updatePromoterShop(data) {
  return fetch({
    url: '/popularize/promoter/shop',
    method: 'put',
    data: data
  })
}

export function editPopularizeGrade(data) {
  return fetch({
    url: '/popularize/promoter/grade',
    method: 'put',
    data: data
  })
}

export function editPopularizeDisabled(data) {
  return fetch({
    url: '/popularize/promoter/disabled',
    method: 'put',
    data: data
  })
}

export function getPromoterGradeConfig() {
  return fetch({
    url: '/popularize/promoter/config',
    method: 'get'
  })
}

export function setPromoterGradeConfig(data) {
  return fetch({
    url: '/popularize/promoter/config',
    method: 'post',
    data: data
  })
}

export function withdrawalApplications(params){
  return fetch({
    url: '/popularize/cashWithdrawals',
    method: 'get',
    params: params
  })
}

export function checkWithdrawal(id, params){
  return fetch({
    url: `/popularize/cash_withdrawals/${id}`,
    method: 'put',
    data: params
  })
}

export function withdrawalPayinfo(id){
  return fetch({
    url: `/popularize/cashWithdrawal/payinfo/${id}`,
    method: 'get'
  })
}

export function withdrawalStatistics(params){
  return fetch({
    url: '/popularize/brokerage/count',
    method: 'get',
    params: params
  })
}

export function getBrokerageLog(params){
  return fetch({
    url: '/popularize/brokerage/logs',
    method: 'get',
    params: params
  })
}

export function exportTaskBrokerageCount(params){
  return fetch({
    url: '/popularize/export/taskBrokerage/count',
    method: 'get',
    params: params
  })
}

export function getTaskBrokerageLog(params){
  return fetch({
    url: '/popularize/taskBrokerage/logs',
    method: 'get',
    params: params
  })
}

export function getTaskBrokerageCountList(params){
  return fetch({
    url: '/popularize/taskBrokerage/count',
    method: 'get',
    params: params
  })
}

export function listCheckInList(params) {
  return fetch({
    url: '/promotions/checkin/getlist',
    method: 'get',
    params: params
  })
}

export function seckillActivityCreate(params){
  return fetch({
    url: '/promotions/seckillactivity/create',
    method: 'post',
    data: params
  })
}
export function seckillActivityUpdateStatus(params){
  return fetch({
    url: '/promotions/seckillactivity/updatestatus',
    method: 'put',
    data: params
  })
}
export function seckillActivityUpdate(params){
  return fetch({
    url: '/promotions/seckillactivity/update',
    method: 'put',
    data: params
  })
}
export function seckillActivityGetList(params){
  return fetch({
    url: '/promotions/seckillactivity/getlist',
    method: 'get',
    params: params
  })
}
export function seckillActivityGetInfo(params){
  return fetch({
    url: '/promotions/seckillactivity/getinfo',
    method: 'get',
    params: params
  })
}

export function seckillActivityWxcode(params){
  return fetch({
    url: '/promotions/seckillactivity/wxcode',
    method: 'get',
    params: params
  })
}

export function getSeckillItemList(params){
  return fetch({
    url: '/promotions/seckillactivity/getIteminfo',
    method: 'get',
    params: params
  })
}

// --start--抽奖活动--

export function getLuckyDrawList (query) {
  return fetch({
    url: '/promotions/luckydraw',
    method: 'get',
    params: query
  })
}

export function getLuckyDrawTeamList (luckydraw_id, query) {
  return fetch({
    url: '/promotions/luckydraw/' + luckydraw_id + '/team/',
    method: 'get',
    params: query
  })
}

export function getLuckyDrawTeamInfo (team_id, query) {
  return fetch({
    url: '/promotions/luckydraw/team/' + team_id,
    method: 'get',
    params: query
  })
}

export function getLuckyDrawInfo (luckydraw_id, query) {
  return fetch({
    url: '/promotions/luckydraw/' + luckydraw_id,
    method: 'get',
    params: query
  })
}

export function createLuckyDrawActivity (params) {
  return fetch({
    url: '/promotions/luckydraw',
    method: 'post',
    data: params
  })
}

export function updateLuckyDrawActivity (luckydraw_id, params) {
  return fetch({
    url: '/promotions/luckydraw/' + luckydraw_id,
    method: 'put',
    data: params
  })
}

export function getMarketingActivityList(params) {
  return fetch({
    url: '/marketing/getlist',
    method: 'get',
    params: params
  })
}

export function getMarketingActivityInfo(params) {
  return fetch({
    url: '/marketing/getinfo',
    method: 'get',
    params: params
  })
}

export function updateMarketingActivity(params) {
  return fetch({
    url: '/marketing/update',
    method: 'put',
    data: params
  })
}

export function addMarketingActivity(params) {
  return fetch({
    url: '/marketing/create',
    method: 'post',
    data: params
  })
}

export function getMarketingActivityItemList (params) {
  return fetch({
    url: '/marketing/getItemList',
    method: 'get',
    params: params
  })
}

export function removeMarketingActivity(params) {
  return fetch({
    url: '/marketing/delete',
    method: 'delete',
    params: params
  })
}

export function finishLuckyDrawActivity (luckydraw_id) {
  return fetch({
    url: '/promotions/luckydraw/finish/' + luckydraw_id,
    method: 'put'
  })
}

export function deleteLuckyDrawActivity (luckydraw_id) {
  return fetch({
    url: '/promotions/luckydraw/' + luckydraw_id,
    method: 'delete'
  })
}

export function luckydrawDelivery (params) {
  return fetch({
    url: '/promotions/luckydraw/delivery',
    method: 'post',
    data: params
  })
}

export function getLuckydrawShow (query) {
  return fetch({
    url: '/promotions/luckydraw_show',
    method: 'get',
    params: query
  })
}
export function setLuckydrawShow (params) {
  return fetch({
    url: '/promotions/luckydraw_show',
    method: 'post',
    data: params
  })
}

// 获取抽奖规则
export function getLuckydrawRules (query) {
  return fetch({
    url: '/promotions/luckydraw_rules',
    method: 'get',
    params: query
  })
}
// 设置抽奖规则
export function setLuckydrawRules (params) {
  return fetch({
    url: '/promotions/luckydraw_rules',
    method: 'post',
    data: params
  })
}
// --end--抽奖活动--

export function saveRecommendLikeItem(params){
  return fetch({
    url: '/promotions/recommendlike',
    method: 'post',
    data: params
  })
}
export function deleteRecommendLikeItem(id){
  return fetch({
    url: '/promotions/recommendlike/' + id,
    method: 'delete',
  })
}
export function getRecommendLikeItemList(params){
  return fetch({
    url: '/promotions/recommendlike',
    method: 'get',
    params: params
  })
}
export function getRecommendLikeItems(params){
  return fetch({
    url: '/promotions/recommendlikes',
    method: 'get',
    params: params
  })
}
export function updateRecommendLikeSort(params) {
  return fetch({
    url: '/promotions/recommendlike',
    method: 'put',
    data: params
  })
}

export function getPackagePromotions(query) {
  return fetch({
    url: '/promotions/package',
    method: 'get',
    params: query
  })
}

export function getPackagePromotionsInfo(id) {
  return fetch({
    url: '/promotions/package/' + id,
    method: 'get'
  })
}

export function createPackagePromotions(params) {
  return fetch({
    url: '/promotions/package',
    method: 'post',
    data: params
  })
}

export function updatePackagePromotions(id, params) {
  return fetch({
    url: '/promotions/package/' + id,
    method: 'put',
    data: params
  })
}

export function cancelPackagePromotions(id) {
  return fetch({
    url: '/promotions/package/cancel/' + id,
    method: 'delete'
  })
}

export function getLimitPromotions(query) {
  return fetch({
    url: '/promotions/limit',
    method: 'get',
    params: query
  })
}

export function getLimitPromotionsInfo(id) {
  return fetch({
    url: '/promotions/limit/' + id,
    method: 'get'
  })
}

export function createLimitPromotions(params) {
  return fetch({
    url: '/promotions/limit',
    method: 'post',
    data: params
  })
}

export function updateLimitPromotions(id, params) {
  return fetch({
    url: '/promotions/limit/' + id,
    method: 'put',
    data: params
  })
}

export function cancelLimitPromotions(id) {
  return fetch({
    url: '/promotions/limit/cancel/' + id,
    method: 'delete'
  })
}

/***线下购买赠送预存款***/
export function getGive(query) {
  return fetch({
    url: '/promotions/give',
    method: 'get',
    params: query
  })
}

export function getGiveInfo(id) {
  return fetch({
    url: '/promotions/give/getInfo/' + id,
    method: 'put'
  })
}
export function createGive(params) {
  return fetch({
    url: '/promotions/give',
    method: 'post',
    data: params
  })
}

export function updateGive(id, params) {
  return fetch({
    url: '/promotions/give/' + id,
    method: 'put',
    data: params
  })
}

export function cancelGive(id) {
  return fetch({
    url: '/promotions/give/cancel/' + id,
    method: 'delete'
  })
}
export function getGiveGoods(params) {
  return fetch({
    url: '/promotions/give/getGoods/'+params.id,
    method: 'put'
  })
}
//   发放日志
export function getGiveLogs(query) {
  return fetch({
    url:"/promotions/give_log",
    method:'get',
    params:query
  })
}
// 补发卡密
export function saveGiveLogs(query) {
  return fetch({
    url:"/promotions/give_log_reissue",
    method:'get'
  })
}

export function buyOnesFreeOnesGetList(params){
    return fetch({
        url: '/promotions/buyonesfreeones',
        method: 'get',
        params: params
    })
}

export function createbuyOnesFreeOnes(params){
    return fetch({
        url: '/promotions/buyonesfreeones',
        method: 'post',
        params: params
    })
}

export function updatebuyOnesFreeOnes(id,params){
    return fetch({
        url: '/promotions/buyonesfreeones/' + id,
        method: 'put',
        params: params
    })
}

export function getBuyonesFreeOnes(id) {
    return fetch({
        url: '/promotions/buyonesfreeones/' + id,
        method: 'get'
    })
}

export function getSendcouponlogList (params) {
  return fetch({
    url: '/promotions/sendcouponlog',
    method: 'get',
    params: params
  })
}

// 0元购活动列
export function getGiftsActivitysList(params) {
    return fetch({
        url: '/promotions/giftsActivitys',
        method: 'get',
        params: params
    })
}
// 0元购活动保存
export function updateGiftsActivity(params) {
    return fetch({
        url: '/promotions/giftsActivity',
        method: 'post',
        params: params
    })
}
// 0元购活动详情
export function getGiftsActivity (id) {
    return fetch({
        url: '/promotions/giftsActivity/'+ id,
        method: 'get',
    })
}
// 0元购活动人员
export function getGiftsActivityUser (params) {
    return fetch({
        url: '/promotions/giftsactivity/users',
        method: 'get',
        params: params
    })
}
// 0元购订单
export function getGiftsActivityOrders(params) {
    return fetch({
        url: '/promotions/giftsactivity/orderlog',
        method: 'get',
        params: params
    })
}
// 设置0元购人员
export function setGiftsActivityUser(params) {
    return fetch({
        url: '/promotions/giftsactivity/createuser',
        method: 'post',
        params: params
    })
}
// 删除0元购人员
export function delGiftActivityUser(id) {
    return fetch({
        url: '/promotions/giftsactivity/del/'+ id,
        method: 'delete',
    })
}

// 活动列表
export function getLotteryActivitysList(params) {
  return fetch({
      url: '/promotions/lotteryActivitys',
      method: 'get',
      params: params
  })
}
//修改状态
export function updateStatus(id, query) {
  return fetch({
      url: '/promotions/update/' + id,
      method: 'put',
      data: query
  })
}
// 新增、修改转盘抽奖
export function updateLottryActivity(params) {
  return fetch({
      url: '/promotions/lotteryActivity',
      method: 'post',
      params: params
  })
}
export function updateLottryActivityy(params) {
  return fetch({
      url: '/promotions/lotteryActivityy',
      method: 'post',
      params: params
  })
}
// 修改单个转盘抽奖
export function updateLottryOne(params) {
  return fetch({
      url: '/promotions/lotteryOne',
      method: 'post',
      params: params
  })
}
// 转盘抽奖活动详情
export function getLotterysActivity (id) {
  return fetch({
      url: '/promotions/lotteryActivity/'+ id,
      method: 'get',
  })
}
//获取抽奖的公司配置
export function getAllCompanyList (query) {
  return fetch({
    url: '/promotions/getCompanyList',
    method: 'get',
    params: query
  })
}

export function getGoodsPresaleList (query) {
  return fetch({
    url: '/promotions/goods/presale',
    method: 'get',
    params: query
  })
}

export function getGoodsPresaleInfo (id) {
  return fetch({
    url: '/promotions/goods/presale/' + id,
    method: 'get'
  })
}

export function addGoodsPresale (params) {
  return fetch({
    url: '/promotions/goods/presale',
    method: 'post',
    data: params
  })
}

export function editGoodsPresale (id, params) {
  return fetch({
    url: '/promotions/goods/presale/' + id,
    method: 'put',
    data: params
  })
}

export function deleteGoodsPresale (id) {
  return fetch({
    url: '/promotions/goods/presale/' + id,
    method: 'delete'
  })
}

export function getWechatLogExport(query) {
  return fetch({
      url : "/promotions/zhuanquactivity/WechatLogExport",
      method: "get",
      params: query
  })
}

export function getUserLogExport(query) {
  return fetch({
      url : "/promotions/zhuanquactivity/UserLogExport",
      method: "get",
      params: query
  })
}



export function getNewCustomerWechatList(query) {
  return fetch({
      url : "/promotions/zhuanquactivity/getWechatLogList",
      method: "get",
      params: query
  })
}

export function getNewCustomerUserLogList(query) {
  return fetch({
      url : "/promotions/zhuanquactivity/getUserLogList",
      method: "get",
      params: query
  })
}

//新人专区企微获取列表
export function getNewCustomerList(query) {
  return fetch({
      url : "/promotions/zhuanquactivity",
      method: "get",
      params: query
  })
}


//新人专区企微获取详情
export function getNewCustomerRow(id) {
  return fetch({
      url : "/promotions/zhuanquactivity/getRow/"+id,
      method: "get",
  })
}

//新人专区企微保存
export function saveNewCustomer(data) {
  return fetch({
      url : "/promotions/zhuanquactivity",
      method: "post",
      data: data
  })
}

//新人专区企微编辑
export function editNewCustomer(id,data) {
  return fetch({
      url : "/promotions/zhuanquactivity/"+id,
      method: "put",
      data: data
  })
}

//新人专区企微获取详情
export function delNewCustomer(id) {
  return fetch({
      url : "/promotions/zhuanquactivity/"+id,
      method: "delete",
  })
}

// 剔除活动中的商品
export function removeItem (data) {
  return fetch({
    url: '/promotions/seckillactivity/removeItem',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/promotions.js